<app-breadcrumbs [headerTitle]="'EMPLOYEE DATA'" />
<div class="main-container">
	<app-customer-list
		[payGroupStatuses]="isClientRole ? 'LIVE' : 'LIVE, IMPLEMENTATION'"
		(newCustomerSelectedEvent)="customerSelected($event)"
	></app-customer-list>
</div>
